import { observable } from 'mobx'

import Store from '../shared/store'
import { apiStore } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import Rating from './model'

@apiStore(apiClient)
class RatingStore extends Store {

  @observable loading = false

  @observable collection = []

  @observable current = null

  usesNumericId = false

  constructor(opts = {}) {

    super(opts)

    this.Model = Rating

    this.initAPIStore({
      ...opts,
    })

  }

  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

}

export default RatingStore



// WEBPACK FOOTER //
// ./src/rating/store.js